import { dotsAssignedPageService } from '@/api'

const initialState = () => ({
  all: [],
  isVisible: true
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    count: state => state.all.length,
    myCount: state => providerUserId =>
      state.all.filter(d => d.provider_assigned_to_user_id === providerUserId)
        .length
  },
  actions: {
    async find({ commit, rootState }) {
      try {
        commit('reset')
        const result = await dotsAssignedPageService.find({
          query: {
            page_id: rootState.pages.active.id,
            provider_project_id: rootState.provider.projects.active.id
          }
        })
        console.log('dots', result)
        commit('assign', result)
        return result
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    assign(state, payload) {
      state.all = payload
    },
    add(state, payload) {
      const foundIndex = state.all.findIndex(c => c.id === payload.id)
      if (foundIndex !== -1) return state.all.splice(foundIndex, 1, payload)
      state.all.push(payload)
    },
    reset(state) {
      state.all = []
    },
    visible(state, isVisible) {
      state.isVisible = isVisible
    }
  }
}
